// Auto-generated normalizer for table: CAR_BOOKING.Solicitantes
export function solicitantesNormalize(row) {
  return {
    idSolicitante: row.idSolicitante ?? row.IdSolicitante ?? row['idSolicitante'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['idEmpleado'] ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['idUnidadOrganizacional'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? '',
    empleadoNombre: row.empleadoNombre ?? row.EmpleadoNombre ?? '',
    empleadoNumero: row.empleadoNumero ?? row.EmpleadoNumero ?? '',
    unidadNombre: row.unidadNombre ?? row.UnidadNombre ?? '',
    recibeNotificaciones: row.recibeNotificaciones ?? row.RecibeNotificaciones ?? true,
  };
}